import { useEffect, useState } from "react";
import Categorypic from "../../../components/categorypiker/Categorypic";
import DatePickerBox from "../../../components/datebox/DatePickerBox";
import Inputbox from "../../../components/formcontrols/normal/InputBox";
import MyActiveModalBody from '../../../components/subcompsActivityModal/MyModalBody'
import "./steps.css"
import { Modal } from "react-bootstrap";
import TATModalBody from "../../../components/tatmodal/Tatmodal";
import GoogleMeetSwitch from "../utility/Googlemeetfield";
import Textbox from "../../../components/formcontrols/normal/Texbox";
export default function Step1({iscategory = true,meetingid, formData, setFormData ,Errors}) {
  const [finalTATMinsValue, setFinalTATMinsValue] = useState('');
  const [show, setShow] = useState(null)
  useEffect(()=>{
if(formData){
  setShow(formData?.categoryID ? false : !iscategory ? false : meetingid ? false : true)
  setFinalTATMinsValue(formData?.durationnumber)
}
  },[formData])
  const [TATshow, setTATshow] = useState(false);
  const handleTATClick = () => {
        setTATshow(!TATshow)
    }
    
    const storeTATValueFun = (tat, str) => {
        setFinalTATMinsValue(Number(tat))
setFormData(({
   ...formData,
  duration:str,
  durationnumber:tat
}))
        setTATshow(false)
    }
  const handleChange = (e) => {
    console.log(e, "nameee")
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    console.log(formData, "formdata")
  };

  const closeModal = () => {
    setShow(false)
  }
  const openModal = () => {
    setShow(true)
  }
  const exitModalFromListSelect = (e) => {
    // setShow(e)
  }
  const getCategoryID = (categoryID) => {
    console.log(categoryID,"caggfhedjk")
    setFormData({
      ...formData,
      categoryID: categoryID
    });
    setShow(false)
  }
  const handledatechange = (name, dateString) => {
    setFormData((prev) => ({ ...prev, [name]: dateString }));
  }
  const SwitchChange=(e)=>{
    console.log(e.target.checked,"eeeeeeeeeeee")
    setFormData(({
       ...formData,
      googlemeet:e.target.checked
    }))
  }
  return (
    <div className="meeting-card">
      <div>
        <div className="row">
          <div style={{ display: "flex", gap: "10px", alignContent: "start", width: "100%" }}>
            <div style={{
  background:(!formData.categoryID &&  Errors?.categoryID) ? "#fff2f2" : "var(--brand-light)",
  border:  (!formData.categoryID &&  Errors?.categoryID)
    ? "1px solid #ff4d4f"
    : "1px solid rgba(26, 111, 212, .15)",
  borderRadius: "10px",
  cursor: "pointer",
  boxShadow: (!formData.categoryID &&  Errors?.categoryID) ? "0 0 0 1px #ff4d4f" : "none",
}} onClick={() => {
              openModal()
            }} className='categorymeeting'>
              <Categorypic categoryID={formData?.categoryID} />
            </div>

            <div style={{ width: "100%" }}>
              <Inputbox
               isextra={true}
                wordboundation={{ limit: 50, id: 'meetingnameInput' }}
                htmlFor={"meetingName"}
                label={"MEETING NAME"}
                value={formData.meetingName}
                onChange={(e) => handleChange(e)}
                type="text"
                labelStyle={{ color:(Errors.meetingName && !formData.meetingName) && "red",  display: "flex", alignItems: "Center", fontSize: "16px", fontWeight: "600" }}
                placeholder={`Enter Meeting Name`}
                required={true}
                fieldName="MeetingName"
              />
            </div>
          </div>
        </div>
        <div className="row meetmargin">
          <div className="col-6">

          <Textbox
          isextra={true}
                                            htmlFor={"Description"}
                                            name="Description"
                                            rowlength={4}
                                            id="criticalActivity"
                                            placeholder='Enter Meeting description and agenda...'
                                            fieldName="MeetingDescription"
                                            value={formData.Description}
                                            label={"DESCRIPTION"}
                                            labelStyle={{ display: "flex", alignItems: "Center", fontSize: "16px", fontWeight: "600" }}
                                            readOnly={false}
                                            onChange={(e) => setFormData({
                                              ...formData,
                                              Description:e.target.value
                                            })}
                                        />
          </div>
            <div className="col-6">
              <div className="row">
                <div className="col-12">
 <Inputbox
           isextra={true}
            htmlFor={"Location"}
            label={"LOCATION"}
            value={formData.Location}
            onChange={(e) => handleChange(e)}
            type="text"
            labelStyle={{ color:(Errors.Location && !formData.Location) && "red", display: "flex", alignItems: "Center", fontSize: "16px", fontWeight: "600" }}
            placeholder={`Enter Location`}
            required={true}
            fieldName="MeetingLocation"
          />
                </div>
                <div className="col-6">
<Inputbox
       isextra={true}
            htmlFor={"duration"}
            label={"DURATION"}
            value={formData.duration}
            onClick={() => handleTATClick()}
            type="text"
            labelStyle={{color:(Errors.duration && !formData.duration) && "red", display: "flex", alignItems: "Center", fontSize: "16px", fontWeight: "600" }}
            placeholder={`Select Duration`}
            required={true}
            fieldName="MeetingDuration"
          />
          </div>
          <div className="col-6">
          <DatePickerBox
          error={Errors.Date}
          isextra={true}
            istrue={true}
            label="DATE"
            name="DUEDATE"
            value={formData.Date}
            placeholder="Select Date"
            onChange={(date, dateString) => handledatechange('Date', dateString)}
            fieldName="MeetingDate"
            required={true}
          />
        </div>
              </div>

          </div>
        </div>
      
        <div className="row">
          <div className="col-6">

          </div>
          <div className="col-6">
     <GoogleMeetSwitch
  fieldName={"MeetingGoogleMeet"}
  isChecked={formData?.googlemeet}
  onSwitchChange={(e) => SwitchChange(e)}
/>
          </div>
     
        </div>
      </div>
    <Modal className='allmodalblur' centered id="tatModal" show={TATshow} onHide={() => handleTATClick()} backdrop="static" keyboard={false}>
                                        <Modal.Header closeButton>
                                            <Modal.Title style={{ fontSize: "18px", color: "#0cc1e6", fontWeight: "500" }}>
                                                Select Duration
                                            </Modal.Title>
                                        </Modal.Header>

                                        <Modal.Body>
                                            <TATModalBody callback={storeTATValueFun} defaults={finalTATMinsValue} />
                                        </Modal.Body>
                                    </Modal>
      <Modal style={{zIndex:9999 , backdropFilter:"blur(2px)" , background:"#0000003e"}} centered show={show} onHide={() => closeModal()} id="modal-dialog" backdrop="static" keyboard={false}>

        <Modal.Body style={{ paddingTop: "0px", overflow: "hidden", overflowX: "hidden" }}>
          <MyActiveModalBody callback={getCategoryID} onclose={() => closeModal()} callbackForExitModal={exitModalFromListSelect} />
        </Modal.Body>
      </Modal>
    </div>
  );
}